export default __webpack_public_path__ + "static/media/kanye1.80d3be33.jpeg";